import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of, ReplaySubject, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { HoofdMenuDto } from '../_models/hoofdMenuDto';
import { SubMenuDto } from '../_models/subMenuDto';
import { MenuDto } from '../_models/menuDto';
import { VolledigMenuDto } from '../_models/volledigMenuDto';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getHoofdMenu(): Observable<HoofdMenuDto[]> {
    
    return this.http.get<HoofdMenuDto[]>(this.baseUrl + 'Menu/menu')
    .pipe(
      tap(data => console.log('hoofdmenu opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleError)
    );
  }

  getSubMenu(hoofdmenuId: number): Observable<SubMenuDto[]> {
    
    return this.http.get<SubMenuDto[]>(this.baseUrl + 'Menu/menu/' + hoofdmenuId)
    .pipe(
      tap(data => console.log('submenu opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleError)
    );
  }

  getMenu(hoofdmenuId: number, submenuId: number): Observable<MenuDto[]> {
    
    return this.http.get<MenuDto[]>(this.baseUrl + 'Menu/menu/' + hoofdmenuId + '/' + submenuId)
    .pipe(
      tap(data => console.log('menu opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleError)
    );
  }

  getVolledigMenuLicensePlate(licenseplate: string): Observable<VolledigMenuDto[]> {
    
    return this.http.get<VolledigMenuDto[]>(this.baseUrl + 'Menu/licenseplate/' + licenseplate)
    .pipe(
      tap(data => console.log('menu licenseplate opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleError)
    );
  }

    getVolledigMenuVin(vin: string): Observable<VolledigMenuDto[]> {
    
    return this.http.get<VolledigMenuDto[]>(this.baseUrl + 'Menu/vin/' + vin)
    .pipe(
      tap(data => console.log('menu vin opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleError)
    );
  }

  getVolledigMenuKtype(ktype: number): Observable<VolledigMenuDto[]> {
    
    return this.http.get<VolledigMenuDto[]>(this.baseUrl + 'Menu/ktype/' + ktype)
    .pipe(
      tap(data => console.log('menu opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleError)
    );
  }




  private handleError(err) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err.status}: ${err.body.error}`;
    }
    console.error(err);
    return throwError(errorMessage);
  }


}
